module.exports = __webpack_public_path__ + "img/card_2_ref_2.7e0a31d8.jpg";